import { render, staticRenderFns } from "./VideoLearningHeading.vue?vue&type=template&id=876ed524&scoped=true&"
import script from "./VideoLearningHeading.vue?vue&type=script&lang=js&"
export * from "./VideoLearningHeading.vue?vue&type=script&lang=js&"
import style0 from "./VideoLearningHeading.vue?vue&type=style&index=0&id=876ed524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876ed524",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
